import { flex, screen } from '@ebh/capsule/theme';

export default {
  mainContainer: [
    flex('row'),
    {
      minHeight: '100vh',
    },
  ],
  outletBody: [
    {
      width: '100%',
    },
    screen('md', {
      flex: 1,
    }),
  ],
};
